import React, { Component, Fragment } from "react"
import { Scrollbars } from "react-custom-scrollbars"
import { connect } from "react-redux"
import cx from "classnames"

class RegionDesktop extends Component {
  render() {
    return (
      <Fragment>
        <Scrollbars
          style={{ height: 500, width: "50%" }}
          renderThumbVertical={props => <div {...props} className="thumb-vertical" />}>
          <div className="locationPopupContainer">
            <div className="locationPopupElement locationPopupElementMain">
              <button
                className={cx("locationPopupButton", {
                  locationPopupButtonActive: this.props.regions.currentCity === 766
                })}
                onClick={() => {
                  this.props.setCity({ id: 766, label: "Москва" })
                  this.props.getRegion("moskva")
                }}>
                Москва и МО
              </button>
              <button
                className={cx("locationPopupButton", {
                  locationPopupButtonActive: this.props.regions.currentCity === 824
                })}
                onClick={() => {
                  this.props.setCity({ id: 824, label: "Санкт-Петербург" })
                  this.props.getRegion("sankt-peterburg")
                }}>
                Санкт-Петербург
              </button>
            </div>
            {this.props.regions.data &&
              this.props.regions.data.map((letter, index) => {
                return (
                  <div key={index} className="locationPopupElement">
                    <span>{letter.letter}</span>
                    {letter.values.map((region, idx) => {
                      return (
                        <button
                          key={idx}
                          className={cx("locationPopupButton", {
                            locationPopupButtonActive: this.props.regions.currentRegion === region.id
                          })}
                          onClick={() => {
                            this.props.getRegion(region.id)
                          }}>
                          {region.region}
                        </button>
                      )
                    })}
                  </div>
                )
              })}
          </div>
        </Scrollbars>
        <Scrollbars style={{ height: 500, width: "50%" }}>
          <div className="locationPopupContainer">
            {this.props.regions.currentRegion &&
              this.props.regions.regions[this.props.regions.currentRegion] &&
              this.props.regions.regions[this.props.regions.currentRegion].payload.map((letter, index) => {
                return (
                  <div key={index} className="locationPopupElement">
                    <span>{letter.letter}</span>
                    {letter.values.map((city, idx) => {
                      return (
                        <button
                          key={idx}
                          className={cx("locationPopupButton", {
                            locationPopupButtonActive: this.props.regions.currentCity === city.id
                          })}
                          onClick={() => {
                            this.props.setCity({ id: city.id, label: city.city })
                          }}>
                          {city.city}
                        </button>
                      )
                    })}
                  </div>
                )
              })}
          </div>
        </Scrollbars>
      </Fragment>
    )
  }
}

const mapState = state => ({
  regions: state.regions
})

const mapDispatch = ({ regions: { getRegions, getRegion, setCity, open } }) => ({
  getRegions: () => getRegions(),
  getRegion: region => getRegion(region),
  setCity: city => setCity(city),
  setOpen: () => open()
})
export default connect(
  mapState,
  mapDispatch
)(RegionDesktop)
